import { Box, Typography } from '@mui/material'

import type { PromptBoxProps } from './PromptBox'

interface PromptBoxThinkingOverlayProps {
  color: PromptBoxProps['color']
}

export default function PromptBoxThinkingOverlay({ color }: PromptBoxThinkingOverlayProps) {
  return (
    <Box
      sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: color === 'dark-grey' ? '#00000033' : '#00000066',
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        flexDirection: 'column',
        gap: '8px',
        padding: '22px',
        zIndex: 10000,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
        }}
      >
        <img alt="workforce" src="/img/workforce-logo-sm-white.svg" style={{ height: '24px' }} />
        <Typography variant="h3">thinking</Typography>
        <Typography
          variant="h3"
          sx={{
            width: '24px',
            '&::after': {
              content: '"..."',
              animation: 'ellipsis 1.5s steps(3, end) infinite',
            },
          }}
        />
      </Box>
    </Box>
  )
}
